export default String.raw`
{% assign product = include %}

{% assign currentCartId = '' %}
{% assign currentCartName = '' %}
{% if customer.Carts[1] or customer.Cart.EditedOrderId %}
    {% for cart in customer.Carts %}
        {% if cart.Current %}
            {% assign currentCartId = cart.Id %}
            {% assign currentCartName = cart.Name %}
        {% endif %}
    {% endfor %}
{% endif %}

{% assign unitId = '' %}
{% for unit in product.Units %}
    {% if unit.Default == true or unit.Id == null %}
        {% assign unitId = unit.Id %}
    {% endif %}
{% endfor %}

{% assign directAddToCart = false %}
{% if product.Attributes == null and product.AttributesEditable == null and product.AttributesPolyvalent == null and product.HasAttributes == false %}
    {% assign directAddToCart = true %}
{% elsif product.Attributes | Size == 1 and product.Attributes[0].Name contains '360photo' %}
    {% assign directAddToCart = true %}
{% endif %}

{% if isDiscountItem and page.PageId != config.DefinedPages.Order.Id %}
    {% assign isDiscountItem = false %}
{% endif %}

{% assign ifAvailable = true -%}
{% if product.Availability.Status == 3 -%}
    {% assign ifAvailable = false -%}
{% endif -%}

<div class="swiper-slide related__wrapper" data-index="{{ index }}">
    <div class="related-product">
        <div class="related-product__flags">
            {% for flag in product.Flags limit:2 %}
            {% if product.Archival -%}
                <div class="tile archival">{{ translations.ArchivalProduct}}</div>
		    {% endif -%}
                <div class="tile {{ flag.Type }}">
                    {% if flag.Type == "Reward" %}
                        {{ translations.PointsProduct }}
                    {% else %}
                        {{ flag.Text }}
                    {% endif %}
                </div>
            {% endfor %}
        </div>
        <div class="related-product__image">
            {% if product.Image.Id > 0 and product.Image.Link != null -%}
                <img data-src="img/large/{{product.Image.Id}}/{{product.Image.Link}}" alt="{{product.Image.Alt | H}}" loading="eager" fetchpriority="high"/>
            {% elsif product.Image.ExternalUrl != null -%}
                <img data-src="{{ product.Image.ExternalUrl }}" alt="{{product.Image.Alt | H}}" loading="eager" fetchpriority="high"/>
            {% else -%}
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                </svg>
            {% endif -%}
        </div>
        <div class="related-product__info">
            {% if AIRecommendations -%}
                <a href="{{ page.BaseHref }}{{ product.Url }}?ai-recommendation=true" class="related-product__name">
            {% else -%}
                <a href="{{ page.BaseHref }}{{ product.Url }}" class="related-product__name">
            {% endif -%}
                {{ product.NameNoHtml | H }}
            </a>
            <div class="related-product__info-group">
                {% if customer.HidePrices == true and customer.Authenticated == false %}
                    <div class="label sign-in">
                        <div class="label__icon">
                            <svg width="16" height="19">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{ settings.iconStyle }}"></use>
                            </svg>
                        </div>
                        <span class="label__text">{{ translations.SignInToSeePrice }}</span>
                    </div>
                    <div class="related-product__suggested">
                        {% if product.PreviousPrice != null and customer.HidePrices -%}
                            {% assign whatPrice = translations.Brutto | Downcase -%}
                            {% if customer.Cart.SubtotalPrices -%}
                                {% assign whatPrice = translations.Netto | Downcase -%}
                            {% endif -%}
                            <span class="value">{{ product.PreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
                        {% endif -%}
                    </div>
                {% else %}
                    {% if product.AskForPrice %}
                        <div class="related-product__prices">
                            <b class="related-product__price-current">&nbsp;<span class="currency">&nbsp;</span></b>
                        </div>
                        {% if settings.lowestProductPrice == 'yes' %}
                            <small class="related-product__price-lowest">&nbsp;</small>
                        {% endif %}
                    {% else %}
                        <div class="related-product__prices">
                            <b class="related-product__price-current">{{ product.Price | ToPrice }} <span class="currency">{{ customer.CurrencyExt }}</span></b>
                            {% if product.PreviousPrice != null and product.PreviousPrice > product.Price and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
                                <small class="related-product__price-previous">
                                    {{ product.PreviousPrice | ToPrice }} <span class="currency">{{ customer.CurrencyExt }}</span>
                                </small>
                            {% elseif product.RegularPrice > product.Price and config.ENTERPRISE and settings.minimalPrice == 'minimalPriceNo' %}
                                <small class="related-product__price-previous">
                                    {{ product.RegularPrice | ToPrice }} <span class="currency">{{ customer.CurrencyExt }}</span>
                                </small>
                            {% endif %}
                            <span class="related-product__price-tax">
                                {% if customer.Cart.SubtotalPrices %}
                                    {{ translations.Netto | Downcase }}
                                {% else %}
                                    {{ translations.Brutto | Downcase }}
                                {% endif %}
                            </span>
                        </div>
                        {% if product.DepositValue > 0 -%}
                            <small class="related-product__price-deposit">
                                <div>+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ customer.CurrencyExt }} / {{ product.BasicUnit }}</div>
                            </small>
                        {% endif %}
                        {% if settings.lowestProductPrice == 'yes' %}
                            <small class="related-product__price-lowest">
                                {% if product.MinPrice %}
                                    {{ product.MinPrice | Round: config.DecimalPlacesPrice | ToPrice }}
                                    <span class="currency">{{ customer.CurrencyExt }}</span>
                                    {% if customer.Cart.SubtotalPrices %}
                                        {{ translations.Netto | Downcase }}
                                    {% else %}
                                        {{ translations.Brutto | Downcase }}
                                    {% endif %}
                                    - {{ translations.Price_Omnibus }}
                                {% else %}
                                    &nbsp;
                                {% endif %}
                            </small>
                        {% endif %}
                        {% if  settings.previousPriceAsSuggestedRetailPrice == 'yes' and product.PreviousPrice != null and product.PreviousPrice > product.Price -%}
                            <small class="related-product__price-lowest">
                                {{ product.PreviousPrice | ToPrice}} <span class="currency">{{ customer.CurrencyExt }}</span>
                                {% if customer.Cart.SubtotalPrices -%}
                                    {{translations.Netto | Downcase}}
                                {% else -%}
                                    {{translations.Brutto | Downcase}}
                                {% endif -%}
                                - {{translations.SuggestedRetailPrice}}
                            </small>
                        {% endif -%}
                    {% endif %}
                {% endif %}
            </div>
        </div>

        <div class="related-product__buttons form-js add-to-cart-js container-js">
        {% if customer.HidePrices == 'true' and customer.Authenticated == 'false' %}
            {% if settings.signIn == "page" %}
                <a class="secondary-action-button" aria-label="sign-in" href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" rel="nofollow" title="{{ translations.LogIn }}">
                    {{ translations.LogIn }}
                    <svg width="18" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{ settings.iconStyle }}"></use>
                    </svg>
                </a>
            {% else %}
                <a class="secondary-action-button show-login-popup-js" aria-label="sign-in" rel="nofollow" title="{{ translations.LogIn }}">
                    {{ translations.LogIn }}
                    <svg width="18" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{ settings.iconStyle }}"></use>
                    </svg>
                </a>
            {% endif %}
        {% elseif product.Price == null or product.AskForPrice %}
            <div class="buttons-group">
                <button class="primary-action-button load-product-presentation-form-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="ask-for-price">
                    {{ translations.AskForPrice }}
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% if usr.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}" data-product-id="{{product.Id}}">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% endif -%}
            </div>
        {% elseif ifAvailable == false and product.HasAttributes == false %}
            <div class="buttons-group">
                <button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js no-supply-product-on-controlled-stock-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="notify-about-availability">
                    {{ translations.NotifyAboutAvailability }}
                    <svg width="18" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% if usr.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}" data-product-id="{{product.Id}}">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% endif -%}
            </div>
        {% elseif ifAvailable == false and product.HasAttributes == true %}
            <div class="buttons-group">
                <button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js no-supply-product-on-controlled-stock-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="notify-about-availability">
                    {{ translations.NotifyAboutAvailability }}
                    <svg width="18" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% if usr.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}" data-product-id="{{product.Id}}">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% endif -%}
            </div>       
        {% elseif product.HasAttributes == true %}
            <div class="buttons-group">
                <button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button choose-variant-js">
                    {{ translations.AvailableProductVariants }}
                    <svg class="button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
            </div>
        {% else %}
            <div class="buttons-group">
                <input type="hidden" name="__action" value="Cart/Add">
                <input type="hidden" name="productId" value="{{ product.Id }}">
                <input type="hidden" name="quantity" value="1">
                <button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button add-to-cart-update-client-area-js parent-container-reload-js">
                    {{ translations.AddToCart }}
                    <svg class="button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% if usr.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js{% endif -%}" data-product-id="{{product.Id}}">
                    <svg class="button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{ settings.iconStyle }}"></use>
                    </svg>
                </button>
                {% endif -%}
            </div>
        {% endif %}
        </div>
    </div>
</div>
`